import React from "react";
import DataTable from "react-data-table-component";
import "../../Common/Common.css";
import DataNotFound from "../Data-Not-Found/DataNotFound";
import CustomPagination from "./CustomPagination";
import VybogTALLoaderAnimation from "../Dynamic-Animations/DynamicAnimations";

function Table(props) {
  const {
    columns = [],
    data = [],
    style = {},
    fixedHeader = false,
    fixedHeaderScrollHeight,
    progressPending,
    highlightOnHover,
    progressComponent,
    selectableRows = false,
    selectableRowDisabled,
    title,
    theme = "default",
    currentPage = 1,
    paginationPerPage = 10,
    paginationRowsPerPageOptions = [5, 10, 15, 20],
    className = "global-data-table",
    onChangePage = () => {},
    onChangeRowsPerPage = () => {},
    onSort = () => {},
    sortServer = false,
    onSelectedRowsChange = () => {},
    clearSelectedRows = () => {},
    customStyle = {},
    dataNotFoundMessage = "",
    backgroundColor = "var(--body__background)",
    color = "var(--header__color)",
    pagination = true,
    paginationServer = false,
    paginationTotalRows,
    hideRowsPerPage = true,
    customNoDataFound,
  } = props;
  const shouldShowPagination = pagination && data.length > 0;
  const defaultProgressComponent = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: "140px",
        background: "var(--body__background)",
      }}
    >
      <VybogTALLoaderAnimation/>
    </div>
  );

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: backgroundColor,
        color: color,
        textAlign: "left",
        justifyContent: "left",
        ...customStyle.headCells,
      },
    },
    cells: {
      style: {
        textAlign: "left",
        justifyContent: "left",
        ...customStyle.cells,
      },
    },
    rows: {
      style: {
        backgroundColor: backgroundColor,
        color: color,
      },
    },
    table: {
      style: {
        backgroundColor: backgroundColor,
      },
    },
    pagination: {
      style: {
        backgroundColor: 'var(--body__background)',
        color: 'var(--header__color)',
        borderTopColor: 'var(--border__color)',
      },
      pageButtonsStyle: {
        color: 'var(--header__color)',
        fill: 'var(--header__color)',
        backgroundColor: 'var(--body__background)',
        '&:disabled': {
          color: 'var(--border__color)',
          fill: 'var(--border__color)',
        },
        '&:hover:not(:disabled)': {
          backgroundColor: 'var(--pagination__hover)',
        },
      },
    },
    noData: {
      style: {
        backgroundColor: backgroundColor,
        color: color,
      },
    },
    progress: {
      style: {
        backgroundColor: "var(--body__background)",
        color: "var(--header__color)",
        minHeight: "140px",
      },
    },
  };

  const PaginationComponent = (paginationProps) => (
    <CustomPagination
      {...paginationProps}
      hideRowsPerPage={hideRowsPerPage}
    />
  );

  return (
    <div className="global-table-wrapper">
      <DataTable
        style={style}
        title={title}
        theme={theme}
        columns={columns}
        data={data}
        highlightOnHover={highlightOnHover}
        selectableRows={selectableRows}
        selectableRowDisabled={selectableRowDisabled}
        fixedHeader={fixedHeader}
        fixedHeaderScrollHeight={fixedHeaderScrollHeight}
        progressPending={progressPending}
        progressComponent={progressComponent || defaultProgressComponent}
        pagination={shouldShowPagination}
        paginationServer={paginationServer}
        paginationTotalRows={paginationTotalRows}
        paginationDefaultPage={currentPage}
        paginationPerPage={paginationPerPage}
        paginationRowsPerPageOptions={paginationRowsPerPageOptions}
        paginationComponent={PaginationComponent}
        className={className}
        onChangePage={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
        onSort={onSort}
        sortServer={sortServer}
        onSelectedRowsChange={onSelectedRowsChange}
        clearSelectedRows={clearSelectedRows}
        customStyle={customStyle}
        noDataComponent={customNoDataFound ? customNoDataFound : <DataNotFound dataNotFoundMessage={dataNotFoundMessage} />}
        dataNotFoundMessage={dataNotFoundMessage}
        customStyles={customStyles}
      />
    </div>
  );
}

export default Table;
